/**
 * Saving the project links of a client: one PUT /planning/workspaces/:id per changed project (the call Edit project
 * uses). Every change is tried and every failure kept against its line; nothing is dropped silently.
 */
import { updateProject } from '../../services/ProjectService';
import { errorMessageOf } from '../../utils/apiErrors';
import type { ClientProjectLine, LinkChanges } from './clientProjectLines';

export interface LinkSaveResult {
  /** By line key. */
  errors: Record<string, string>;
  addedOk: Set<string>;
  removedOk: Set<string>;
  saved: number;
  failed: number;
}

export async function saveProjectLinks(clientId: string, changes: LinkChanges): Promise<LinkSaveResult> {
  const result: LinkSaveResult = { errors: {}, addedOk: new Set(), removedOk: new Set(), saved: 0, failed: 0 };
  const run = async (line: ClientProjectLine, clientValue: string | null, ok: Set<string>, fallback: string) => {
    try {
      await updateProject(line.projectId, { client_id: clientValue });
      ok.add(line.projectId);
      result.saved += 1;
    } catch (err) {
      result.errors[line.key] = errorMessageOf(err, fallback);
      result.failed += 1;
    }
  };
  for (const line of changes.remove) await run(line, null, result.removedOk, "Couldn't take this project off the client.");
  for (const line of changes.add) await run(line, clientId, result.addedOk, "Couldn't link this project to the client.");
  return result;
}
